import "regenerator-runtime/runtime";

import React, { Component } from "react";
import InfiniteList from "react-infinite-scroll-list";

const createPlaceholderElement = (items = []) =>
  new Array(25).fill(null).map((_, index) => {
    const value = items.length + index;

    return {
      id: value,
      message: `Placeholder ${value}`
    };
  });

class VerticalList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [],
      isLoading: false,
      isEndReached: false
    };

    this.onReachThreshold = this.onReachThreshold.bind(this);
  }

  async onReachThreshold() {
    console.log("onReachThreshold");

    this.setState({ isLoading: true });

    console.log("loading...");

    let response = await fetch(
      `/fashion/infinite_load_more?page=${this.state.items.length}`
    );

    let data = await response.json();
    console.log("data: ", data);

    this.setState(({ items }) => {
      return {
        isLoading: false,
        items: items.concat(data)
      };
    });
  }

  renderItems = () => {
    return this.state.items.map(item => (
      <div key={item.id} dangerouslySetInnerHTML={{ __html: item.html }} />
    ));
  };

  render() {
    return (
      <InfiniteList
        root="fashion-vertiocal"
        isLoading={this.state.isLoading}
        isEndReached={this.state.isEndReached}
        onReachThreshold={this.onReachThreshold}
        containerClassName="fashion-vertical"
        sentinelClassName="custom-sentinel-class-name"
        containerTagName="div"
        sentinelTagName="div"
        threshold={200}
      >
        {this.renderItems()}

        {this.state.isLoading && (
          <li className="InfiniteList__Item">Loading...</li>
        )}
      </InfiniteList>
    );
  }
}

export default VerticalList;
